import { render, staticRenderFns } from "./ipSwiperList.vue?vue&type=template&id=647a3242&scoped=true&"
import script from "./ipSwiperList.vue?vue&type=script&lang=js&"
export * from "./ipSwiperList.vue?vue&type=script&lang=js&"
import style0 from "./ipSwiperList.vue?vue&type=style&index=0&id=647a3242&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a3242",
  null
  
)

export default component.exports